/* eslint-disable import/no-unresolved */
import React, { useEffect, useRef, useState } from 'react';

import './roller.scss'
import './Home.scss'
import './animations.scss';
import styled from 'styled-components';
import icBack from 'static/ic-back.png';
import icCoin from 'static/ic-coin.png';
import icColorRotate from 'static/ic-color-rotate.png';
import icUnmute from 'static/ic-unmute.png';
import icMute from 'static/ic-mute.png'
import icAutoOn from 'static/ic-auto-on.png';
import icAutoOff from 'static/ic-auto-off.png';
import icInfo from 'static/ic-info.png';
import icCup from 'static/ic-cup.png';
import icBook from 'static/ic-book.png';
import icPieace from 'static/ic-piece.png';
import icFlicker from 'static/ic-flicker-light.png';
import icBgFlicker from 'static/ic-flicker-background.png';
import bgHome from 'static/bg-home.png';
import bgToolbar from 'static/bg-toolbar.png'
import bgReelBlue from 'static/bg-reel-blue.webp';
import bgReelAqua from 'static/bg-reel-aqua.webp';
import bgReelOrange from 'static/bg-reel-orange.webp';
import bgReelPink from 'static/bg-reel-pink.webp';
import bgReelPurple from 'static/bg-reel-purple.webp';
import ellipseToolbar from 'static/ellipse-336.png';
import ModalInfo from './components/ModalInfo';
import ModalWinPrize from './components/ModalWinPrize';
import ModalRank from './components/ModalRank';
import ModalHistory from './components/ModalHistory';
import { DIAL_RESPONSE, DROP_TITLE, GAMECODE_LIST, HISTORY_LIST, MODAL_TYPE, NATIVE_ACTION, PAGE, PRIZE_CODE, PRIZE_TYPE, GAME_CODE_THEME_NEW } from 'helpers/constants';
import ModalBeeCoin from './components/ModalBeeCoin';
import DropBanner from 'components/DropBanner';
import PuzzleStorage from './components/PuzzleStorage';
import { dial, getHistoryFilter, getInfo } from 'services';
import { getRandom, getRandomArrayFromTo, numberFormat } from 'helpers/helpers';
import { connect } from 'react-redux';
import ModalUnexpected from 'components/ModalUnexpected';
import ModalUnexpectedNew from 'components/ModalUnexpectedNew';
import { history } from 'store';
import rollMusic from 'static/music/rolling.mp3';
import bgFooter from 'static/bg-footer.png';
import useSound from 'use-sound';
import { handleNativeAction } from 'helpers/nativeActions';
import { getGameAsset } from 'helpers/gameAssets';
import * as selectors from "store/selectors";
import { setSound } from 'store/common';
import moment from 'moment';
import _ from 'lodash';
import { toast } from 'react-toastify';
import rollImage from 'static/roll_image.png';

const HomePage = styled.div`
  background-image: url(${bgHome});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
`;

const Loading = styled.div`
    position: absolute;
    float: none;
    background: transparent;
    padding-top: 40vh;
`

const Spinner = styled.div`
    border: 3px solid red;
    border-right-color: transparent;
`


function Home(props) {
  const destination = props.location.state?.destination;
  const [modal, openModal] = useState(null);
  const [auto, setAuto] = useState(false);
  // const [rolling, setRollStatus] = useState(false);
  const rolling = useRef(false);
  const soundRef = useRef(props.sound);
  const forceStop = useRef(false);
  const dialData = useRef({});
  const [gameInfo, setGameInfo] = useState(props.location.state?.gameInfo || {});
  const [config, setConfigModal] = useState({ message: "Đã có lỗi xảy ra", btnLabel: "Đóng", callback: () => openModal(null) });
  const [loading, setLoading] = useState(false);
  const [isMounting, setMountingDone] = useState(false);
  useEffect(() => {
    setMountingDone(true);
    console.log("Home mouting done!");
    switch (destination) {
      case "MAGIC":
        handleOpenMagic();
        break;

      default:
        break;
    }
  }, []);
  const historyList = useRef([]);
  const gameCode = props.location.state?.gameCode;
  const baseBackground = getGameAsset(gameCode, 'bg-home', bgHome);
  const gameBackground = getGameAsset(gameCode, 'bg-home-new', bgHome);
  const rollImageNew = getGameAsset(gameCode, 'roll_image', rollImage);
  const bgReelSurface = getGameAsset(gameCode, 'bg-surface-reel', null);
  const reelBackgrounds = {
    blue: getGameAsset(gameCode, 'bg-reel-blue', bgReelBlue),
    purple: getGameAsset(gameCode, 'bg-reel-purple', bgReelPurple),
    pink: getGameAsset(gameCode, 'bg-reel-pink', bgReelPink),
    orange: getGameAsset(gameCode, 'bg-reel-orange', bgReelOrange),
    aqua: getGameAsset(gameCode, 'bg-reel-aqua', bgReelAqua),
  };
  const reelBackgroundOrder = GAME_CODE_THEME_NEW.includes(gameCode)
    ? [reelBackgrounds.blue, reelBackgrounds.aqua, reelBackgrounds.orange, reelBackgrounds.pink, reelBackgrounds.purple, reelBackgrounds.blue]
    : [bgReelBlue, reelBackgrounds.purple, reelBackgrounds.pink, reelBackgrounds.orange, reelBackgrounds.aqua, reelBackgrounds.blue];
  const [play, { stop }] = useSound(rollMusic);
  const togglePlay = () => {
    if (rolling.current) {
      if (!soundRef.current) play();
      else stop();
    }
    soundRef.current = !props.sound;
    props.setSound();
  }

  let icon_width = 80, // Width of the icons
    icon_height = 100, // Height of one icon in the strip
    num_icons = 10, // Number of icons in the strip
    num_rells = 6,
    // rewardArr = getRandomArrayFromTo(1, 6, num_rells);
    rewardArr = [0, 0, 0, 0, 0, 0];
  /** 
   * Roll one reel
   */
  const roll = (reel, offset = 0, id) => {
    // Minimum of 2 + the reel offset rounds
    const delta = (offset + 2) * num_icons + id;//Math.round(Math.random() * num_icons); 
    const time_per_icon = 10; // roll speed
    // console.log('id: ', id, ' delta:', delta, ' offset: ', offset);
    // Return promise so we can wait for all reels to finish
    return new Promise((resolve, reject) => {

      // reel.style.backgroundPositionY = `-47px`;
      const style = getComputedStyle(reel),
        // Current background position
        backgroundPositionY = parseFloat(style["background-position-y"]),
        // Target background position
        targetBackgroundPositionY = backgroundPositionY + delta * icon_height,
        // Normalized background position, for reset
        normTargetBackgroundPositionY = targetBackgroundPositionY % (num_icons * icon_height);
      // normTargetBackgroundPositionY = backgroundPositionY;
      // Delay animation with timeout, for some reason a delay in the animation property causes stutter
      setTimeout(() => {
        // Set transition properties ==> https://cubic-bezier.com/#.41,-0.01,.63,1.09
        // reel.style.transition = `background-position-y ${(8 + 1 * delta) * time_per_icon}ms cubic-bezier(.41,-0.01,.63,1.09)`;
        reel.style.transition = `background-position-y ${500}ms cubic-bezier(.41,-0.01,.63,1.09)`;

        // Set background position
        reel.style.backgroundPositionY = `${backgroundPositionY + delta * icon_height}px`;
        // }, offset * 100); // timeout delay reel each other
      }, 0);
      // After animation
      setTimeout(() => {
        // Reset position, so that it doesn't get higher without limit
        reel.style.transition = `none`;
        reel.style.backgroundPositionY = `${normTargetBackgroundPositionY}px`;
        // reel.style.backgroundPositionY = `${icon_height}px`;
        // Resolve this promise
        resolve(delta % num_icons);
        // }, (8 + 1 * delta) * time_per_icon + offset * 150);
        // }, !dialData.current.dialedNumber ? 400 : (8 + 1 * delta) * time_per_icon + offset * 150);
      }, 400);
    });
  };

  const doRoll = (isLastTime) => {
    // if (soundRef.current && !sound.playing()) {
    //   play();
    // }
    const reelsList = document.querySelectorAll('.box > .reel');
    Promise

      // Activate each reel, must convert NodeList to Array for this with spread operator
      .all([...reelsList].map((reel, i) => roll(reel, i, rewardArr[i])))

      // When all reels done animating (all promises solve)
      .then((deltas) => {
        if (forceStop.current) return; // Have an error when rolling
        if (isLastTime) { // Roll last time when have response
          stop();
          console.log("Open win");
          // rolling.current = false;
          // Update game info on client, not recall getInfo
          setGameInfo({
            ...gameInfo,
            currentPoint: gameInfo.currentPoint - 1,
            pointUsedInDay: gameInfo.pointUsedInDay + 1,
            currentCoin: dialData.current.dialRewardType === PRIZE_TYPE.COIN ? gameInfo.currentCoin + Number(dialData.current.dialRewardValue) : gameInfo.currentCoin
          });
          setTimeout(() => openModal(MODAL_TYPE.WIN_PRIZE), 600);
        } else {
          if (_.isEmpty(dialData.current)) { // Still don't have response
            doRoll();
          } else { // Have response
            if (!!dialData.current.dialRewardType) {// If lose, dialRewardType = ""
              // Setup reward elementj
              // This is fix value "1000000" reason by bussiness
              if (dialData.current.dialRewardType === PRIZE_TYPE.MONEY && dialData.current.dialRewardValue === "1000000" || dialData.current.dialRewardType !== PRIZE_TYPE.MONEY) {
                rewardArr[getRandom(num_rells)] = PRIZE_CODE[dialData.current.dialRewardType];
              }
            } else {
              rewardArr = getRandomArrayFromTo(1, 6, num_rells);
            }
            doRoll(true); // Start last-time roll
          }
        }
      });
  }

  /**
   * Roll all reels, when promise resolves roll again
   */
  const rollAll = async () => { // Check rolling in case auto but still click button roll
    rolling.current = true;
    dialData.current = {}; //reset roll data
    forceStop.current = false;
    // Check all point and remaining point for the day
    if (gameInfo.currentPoint < 1) {
      rolling.current = false;
      openGameEnded();
      // openPointEmpty();
      return;
    }
    // Check game expired
    const endDate = props.location.state?.endDate;
    if (endDate) {
      const expired = endDate.split(" ")[0] + " " + endDate.split(" ")[1];
      if (!moment(expired, "YYYY-MM-DD HH:mm:ss").isAfter(new Date())) {
        rolling.current = false;
        openGameExpired();
        return;
      }
    }

    if (soundRef.current) { play(); }

    // setRollStatus(true); // Disable all action when rolling
    let index = 1
    console.log(index);
    const interval = setInterval(() => {
      if (index > 4) {
        clearInterval(interval);
        forceStopGame();
        // setConfigModal({ message: "Request timeout!", btnLabel: "Đóng", callback: () => openModal(null) });
        toast.error("Request timeout!");
        openModal(MODAL_TYPE.UN_EXPECTED);
      }
      console.log(++index);
    }, 1000);
    doRoll();
    handleNativeAction(NATIVE_ACTION.INS_QUAYONG);

    const response = await props.dial({ gameCode: gameCode });
    // const response = DIAL_RESPONSE;
    clearInterval(interval);
    if (response && response.result && response.result.ok && response.dialData) {
      const { dialRewardType, dialRewardValue, dialRewardName } = response.dialData;
      dialData.current = response.dialData;

      //Send insider
      if (dialRewardType === PRIZE_TYPE.COIN || dialRewardType === PRIZE_TYPE.MONEY) {
        handleNativeAction(NATIVE_ACTION.INS_QUAYONG_TRUNGTHUONG, { ins_transaction_type: dialRewardName, ins_transaction_amount_int: dialRewardValue });
      } else if (!!dialRewardType) { // Others reward
        handleNativeAction(NATIVE_ACTION.INS_QUAYONG_TRUNGTHUONG, { ins_transaction_type: dialRewardName, ins_transaction_amount_int: 1 });
      }

    } else if (response && response.result && !response.result.ok) { // Response an error
      forceStopGame();
      switch (response.result.responseCode) {
        case "GW100":
        case "GW582":
          openGameExpired();
          break;
        case "GW377":
          openPointEmpty();
          break;
        case "GW373":
          openPointOverflow();
          break;
        case "GW616":
          openGameEnded();
          break;
        default:
          toast.error(response?.result?.message);
          openModal(MODAL_TYPE.UN_EXPECTED);
          break;
      }
    }
    else {
      forceStopGame();
      toast.error(response?.result?.message);
      setConfigModal({ message: "Đã có lỗi xảy ra", btnLabel: "Đóng", callback: () => openModal(null) });
      openModal(MODAL_TYPE.UN_EXPECTED);
    }
    // }, 5000);
  };

  const forceStopGame = () => {
    dialData.current = {};
    forceStop.current = true;
    rolling.current = false;
    stop();
  }

  const openPointOverflow = () => {
    setConfigModal({
      message: "Bạn đã đạt giới hạn lượt quay trong ngày. Hãy trở lại vào ngay mai.",
      btnLabel: "Đóng",
      callback: () => openModal(null)
    });
    openModal(MODAL_TYPE.UN_EXPECTED);
  }

  const openPointEmpty = () => {
    setConfigModal({
      message: "Hiện tại bạn không có lượt quay nào, vui lòng sử dụng các sản phẩm, dịch vụ trên app MB để có thêm lượt quay nhé",
      btnLabel: "Đóng",
      callback: () => openModal(null)
    });
    openModal(MODAL_TYPE.UN_EXPECTED);
  }

  const openGameEnded = () => {
    setConfigModal({
      message: "Vòng quay \"Quay thật sung - Trúng cực khủng\" đã kết thúc! Bạn có thể xem mã số dự thưởng Giải Ong Chúa 500 triệu trong Menu \"Lịch sử\". Lễ quay thưởng sẽ được tổ chức vào ngày 8/1/2025",
      btnLabel: "Đóng",
      callback: () => openModal(null)
    });
    openModal(MODAL_TYPE.UN_EXPECTED_NEW);
  }

  const openGameExpired = () => {
    setConfigModal({
      message: "Chương trình đã kết thúc. Vui lòng theo dõi các chương trình khuyến mãi tiếp theo từ MBBank nhé.",
      btnLabel: "Đóng",
      callback: () => openModal(null)
    });
    openModal(MODAL_TYPE.UN_EXPECTED);
  }

  const goBack = () => {
    if (props.location.state?.isFromSplash) {
      handleNativeAction(NATIVE_ACTION.ONG_VANG_WEB, { action: "quit" });
    } else {
      history.goBack();
    }
  };

  const handleCloseWinModal = () => {
    rolling.current = false;
    dialData.current = {};
    openModal(null);
    if (auto) {
      rollAll();
    }
  }

  const handleOpenMagic = async () => {
    setLoading(true);
    const result = await props.getHistoryFilter({ gameCode: gameCode, prizeType: PRIZE_TYPE.MAGIC });
    const magicHistory = result && result.historyList ? result.historyList : [];
    setLoading(false);
    // const magicHistory = [...HISTORY_LIST]; // Testing data
    historyList.current = magicHistory;
    openModal(MODAL_TYPE.FUSION);
    handleNativeAction(NATIVE_ACTION.INS_QUAYONG_GHEPMANH_VIEW);
  }

  return (
          <HomePage
      className={`home-page ${GAME_CODE_THEME_NEW.includes(gameCode) ? 'mb32-home' : ''}`}
      style={{ backgroundImage: `url(${baseBackground})` }}
    >
      {!modal &&
        <div>
          <div className="container">
            <img className="absolute flicker flicker-bg" src={icBgFlicker} />
            <div className='d-flex justify-content-center t-[15vh] game-header-wrap'>
              <div className='game-header'>
                <img className='icon-header' src={icBack} onClick={() => !rolling.current && goBack()} />
                {GAME_CODE_THEME_NEW.includes(gameCode) ? <></> : 
                  <div className="btn-group" onClick={() => !rolling.current && handleOpenMagic()}>
                    <img src={icPieace} style={{ left: '-5px', height: '2.375rem' }} />
                    <button className='btn-header btn-action'>Kho mảnh ghép</button>
                    <img className="animate-flicker flicker flicker_main" src={icFlicker} />
                    <img className="animate-flicker flicker flicker_sub animation-delay-5" src={icFlicker} />
                  </div>
                }

                <div className="btn-group">
                  <img src={icColorRotate} style={{ left: '-7px', height: '3rem', width: "3rem" }} alt="ic-turn" />
                  <button className='btn-header'><b>{numberFormat(gameInfo.currentPoint, ".")}</b> Lượt quay</button>
                  <img className="animate-flicker flicker flicker_main" src={icFlicker} />
                  <img className="animate-flicker flicker flicker_sub animation-delay-5" src={icFlicker} />
                </div>
                {GAME_CODE_THEME_NEW.includes(gameCode) ? <></> : 
                  <div className="btn-group" onClick={() => !rolling.current && openModal(MODAL_TYPE.COIN)}>
                    <img src={icCoin} style={{ left: 0, height: '2.25rem' }} />
                    <button className='btn-header btn-action'><b>{numberFormat(gameInfo.currentCoin, ".")}</b> Xu ong</button>
                    <img className="animate-flicker flicker flicker_main" src={icFlicker} />
                    <img className="animate-flicker flicker flicker_sub animation-delay-5" src={icFlicker} />
                  </div>
                }
              </div>
            </div>
            <div className="game-center">
              <div className="box-background" style={{backgroundImage: `url(${bgReelSurface})`}} >
                <div className="slots">
                  {reelBackgroundOrder.map((background, index) => (
                    <div className='box' key={index} style={{ "--bg-reel-after": `url(${background})` }}>
                      <div className="reel" style={{backgroundImage: `url(${rollImageNew})`}}></div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Toolbar */}
              <div className="toolbar">
                <img className='bgToolbar' src={getGameAsset(gameCode, 'bg-toolbar', bgToolbar)} />
                <img className="ellipse" src={ellipseToolbar} />
                <div className="toolbar-content">
                  <div onClick={() => togglePlay()}>
                    <img src={soundRef.current ? icUnmute : icMute} style={{ height: "1.125rem" }} />
                    <p className="py-1">{soundRef.current ? "Bật âm" : "Tắt âm"}</p>
                  </div>
                  <div onClick={() => setAuto(!auto)}>
                    <img className="mt-3" src={auto ? icAutoOff : icAutoOn} style={{ height: "1.125rem" }} />
                    <p className="py-1 pb-3">Tự động</p>
                  </div>
                  <div onClick={() => !rolling.current && openModal(MODAL_TYPE.INFO)}>
                    <img src={icInfo} style={{ height: "1.125rem" }} />
                    <p className="py-1">Thể lệ</p></div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="game-footer">
            <img src={bgFooter} className='left-0 w-100' />
            {/* Footer  content */}
            <div className="d-flex justify-content-between align-items-center game-footer-content">

              <div className="btn-group" onClick={() => !rolling.current && openModal(MODAL_TYPE.RANK)}>
                <div className='shake absolute' style={{ top: 0, left: 0, width: "2.5rem", height: "36px" }}>
                  <img className="" src={icCup} alt="ic-cup" style={{ top: "-.5rem", left: "-.75rem" }} />
                  <img className="animate-flicker  flicker_main" src={icFlicker} />
                  <img className="animate-flicker flicker_sub animation-delay-5" src={icFlicker} />
                </div>
                <button className="btn-footer">BẢNG XẾP HẠNG</button>
              </div>

              <div className="btn-group" onClick={() => !rolling.current && openModal(MODAL_TYPE.HISTORY)}>
                <img src={icBook} alt="ic-book" style={{ height: "3rem" }} />
                <img className="animate-flicker flicker flicker_main" src={icFlicker} />
                <img className="animate-flicker flicker flicker_sub animation-delay-5" src={icFlicker} />
                <button className="btn-footer">LỊCH SỬ</button>
              </div>

              {/* Button Roll  */}
              <div className="btn-roll" onClick={() => {
                if (rolling.current) console.log("Game rolling");
                else rollAll();
              }} >
                <img className=" animate-flicker flicker flicker_main" src={icFlicker} style={{ top: ".5rem", left: "-.5rem" }} />
              </div>
            </div>
          </div>
          {modal === MODAL_TYPE.WIN_PRIZE && <canvas id="confetti" hidden></canvas>}
        </div>
      }
      {isMounting && <ModalInfo
        isOpen={modal === MODAL_TYPE.INFO}
        onCloseModal={() => openModal(null)}
        gameCode={gameCode}
      />}
      {modal === MODAL_TYPE.WIN_PRIZE && < ModalWinPrize
        isOpen={modal === MODAL_TYPE.WIN_PRIZE}
        prizeType={dialData.current.dialRewardType}
        title={dialData.current.dialRewardName}
        message={dialData.current.dialRewardDescription}
        onCloseModal={() => handleCloseWinModal()}
        isAuto={auto}
        gameCode={gameCode}
      />}

      {isMounting && <ModalHistory isOpen={modal === MODAL_TYPE.HISTORY}
        onCloseModal={() => openModal(null)}
        gameCode={gameCode}
      />}

      {isMounting && <ModalRank
        isOpen={modal === MODAL_TYPE.RANK}
        onCloseModal={(modal) => openModal(modal)}
        gameCode={gameCode}
      />}
      {isMounting && <ModalBeeCoin
        isOpen={modal === MODAL_TYPE.COIN}
        onCloseModal={() => openModal(null)}
        totalCoin={gameInfo.currentCoin}
        gameCode={gameCode}
      />}
      {isMounting && <PuzzleStorage
        isOpen={modal === MODAL_TYPE.FUSION}
        onCloseModal={(modal) => openModal(modal)}
        gameCode={gameCode}
        historyList={historyList.current}
      />}
      {modal === MODAL_TYPE.UN_EXPECTED && <ModalUnexpected
        isOpen={modal === MODAL_TYPE.UN_EXPECTED}
        onCloseModal={config.callback}
        message={config.message}
        btnLabel={config.btnLabel}
        gameCode={gameCode} />}

      {modal === MODAL_TYPE.UN_EXPECTED_NEW && <ModalUnexpectedNew
        isOpen={modal === MODAL_TYPE.UN_EXPECTED_NEW}
        onCloseModal={config.callback}
        message={config.message}
        btnLabel={config.btnLabel}
        gameCode={gameCode} />}
      {loading && <Loading className="overlay">
        <Spinner className="spinner" />
      </Loading>}
    </HomePage>
  );
}
const mapStateToProps = (state) => ({
  sound: selectors.getSound(state),
})

const mapDispatchToProps = dispatch => ({
  dial: params => dispatch(dial(params)),
  // getInfo: params => dispatch(getInfo(params)),
  getHistoryFilter: params => dispatch(getHistoryFilter(params)),
  setSound: () => dispatch(setSound())
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);